import {Component, input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {MatDivider} from "@angular/material/divider";

@Component({
	selector: "sim-panel-content-warning-container",
	templateUrl: "./panel-content-warning-container.component.html",
	styleUrls: ["./panel-content-warning-container.component.scss"],
	imports: [TranslateModule, MatDivider],
})
export class PanelContentWarningContainerComponent {
	warningTitle = input.required<string>();
	warningDescription = input.required<string>();
}
